import backend from "../../../services/axios.functions";
import { User } from "../types/user.interface";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";

export function fetchUser(userId: number): Observable<User> {
  return from(backend.get<User>(`/users/${userId}/`)).pipe(map((response) => response.data));
}
